export default __webpack_public_path__ + "/dist/images/image00011.cfa371d094f5a0f55ff1d7b3c4960cba.jpg";